// GET ADMIN USERS SWAP HISTORY

import { adminApi } from "../../../service/admin-api";
import { notificationsSuccessShow, notificationsErrorShow } from '../notifications';

export const GET_ADMIN_USERS_SWAP_HISTORY_REQUEST = 'GET_ADMIN_USERS_SWAP_HISTORY_REQUEST';
export const GET_ADMIN_USERS_SWAP_HISTORY_SUCCESS = 'GET_ADMIN_USERS_SWAP_HISTORY_SUCCESS';
export const GET_ADMIN_USERS_SWAP_HISTORY_FAIL = 'GET_ADMIN_USERS_SWAP_HISTORY_FAIL';
export const GET_ADMIN_SWAP_HISTORY_TOTAL_REQUEST = 'GET_ADMIN_SWAP_HISTORY_TOTAL_REQUEST';
export const GET_ADMIN_SWAP_HISTORY_TOTAL_SUCCESS = 'GET_ADMIN_SWAP_HISTORY_TOTAL_SUCCESS';

const getAdminUsersSwapHistoryRequest = () => ({
  type: GET_ADMIN_USERS_SWAP_HISTORY_REQUEST
});

const getAdminUsersSwapHistorySuccess = payload => ({
  type: GET_ADMIN_USERS_SWAP_HISTORY_SUCCESS,
  payload
});

const getAdminUsersSwapHistoryFail = payload => ({
  type: GET_ADMIN_USERS_SWAP_HISTORY_FAIL,
  payload
});

const getAdminSwapHistoryTotalRequest = () => ({
  type: GET_ADMIN_SWAP_HISTORY_TOTAL_REQUEST
});

const getAdminSwapHistoryTotalSuccess = payload => ({
  type: GET_ADMIN_SWAP_HISTORY_TOTAL_SUCCESS,
  payload
});

export const getAdminUsersSwapHistory = dispatch => async (body) => {
  getAdminSwapTotal(dispatch)(body);
  dispatch(getAdminUsersSwapHistoryRequest());
  const data = { order: 'DESC', ...body };
  try {
    const response = await adminApi.getAdminUsersSwapHistory(data);
    dispatch(getAdminUsersSwapHistorySuccess(response.data));
  } catch (error) {
    dispatch(getAdminUsersSwapHistoryFail(error?.data));
  }
};

export const getAdminSwapTotal = dispatch => async (body) => {
  dispatch(getAdminSwapHistoryTotalRequest());

  try {
    const response = await adminApi.getAdminSwapTotal(body);
    dispatch(getAdminSwapHistoryTotalSuccess(response.data));
  } catch (error) {
    dispatch(notificationsErrorShow(error.data));
  }
};
